import datePresetCatalog from "../../../config/report_date_presets.json"

interface DatePresetEntry {
  key: string
  label: string
  kind:
    | "trailing_days"
    | "month_to_date"
    | "previous_month"
    | "year_to_date"
    | "previous_year"
  days?: number
}

export const REPORT_DATE_PRESETS = datePresetCatalog as DatePresetEntry[]

export function reportDatePreset(key: string | null | undefined) {
  return REPORT_DATE_PRESETS.find((preset) => preset.key === key) ?? null
}

export function reportDatePresetForTrailingDays(days: number | undefined) {
  if (!days) return null
  return (
    REPORT_DATE_PRESETS.find(
      (preset) => preset.kind === "trailing_days" && preset.days === days,
    ) ?? null
  )
}

function isoDate(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0",
  )}-${String(date.getDate()).padStart(2, "0")}`
}

/** Resolve against the browser's local calendar, mirroring DatePresets in Ruby. */
export function resolveReportDatePreset(
  key: string,
  now = new Date(),
): { start: string; end: string; preset: string } | null {
  const preset = reportDatePreset(key)
  if (!preset) return null

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  let start: Date
  let end = today
  switch (preset.kind) {
    case "trailing_days":
      start = new Date(today)
      start.setDate(start.getDate() - ((preset.days ?? 1) - 1))
      break
    case "month_to_date":
      start = new Date(today.getFullYear(), today.getMonth(), 1)
      break
    case "previous_month":
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1)
      end = new Date(today.getFullYear(), today.getMonth(), 0)
      break
    case "year_to_date":
      start = new Date(today.getFullYear(), 0, 1)
      break
    case "previous_year":
      start = new Date(today.getFullYear() - 1, 0, 1)
      end = new Date(today.getFullYear() - 1, 11, 31)
      break
  }
  return { start: isoDate(start), end: isoDate(end), preset: preset.key }
}

function sortForComparison(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sortForComparison)
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([, item]) => item !== undefined)
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, item]) => [key, sortForComparison(item)]),
    )
  }
  return value
}

export function reportConfigFingerprint(value: unknown): string {
  return JSON.stringify(sortForComparison(value))
}
